import { render } from "./ResourcesComponent.vue?vue&type=template&id=41e909a4&scoped=true"
import script from "./ResourcesComponent.vue?vue&type=script&lang=js"
export * from "./ResourcesComponent.vue?vue&type=script&lang=js"

import "./ResourcesComponent.vue?vue&type=style&index=0&id=41e909a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e909a4"]])

export default __exports__